import React from "react";
import moment from "moment";
import ReactGA from "react-ga";
import _, { isEmpty } from "lodash";
import { UserLinkObj } from "types";
import { AppCtx } from "data/context";
import { IMAGE_URL } from "config/Api";
import BankDetails from "./BankDetails";
import EventBooking from "./EventBooking";
import PersonalInfo from "./PersonalInfo";
import { DisplayIcon } from "components/ui";
import { vCard } from "./ContactCard/vCard";
import EmergencyContact from "./EmergencyContact";
import { useSearchParams } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import MultiDocumentView from "./MultiDocumentView";

interface Props {
  userData: any;
}

const MyProfile: React.FC<Props> = ({ userData }) => {
  const [searchParams] = useSearchParams({
    tableNo: "",
  });
  const activeView = searchParams.get("tableNo");
  const { isOpen, setIsOpen } = React.useContext(AppCtx);
  const [listData, setListData] = React.useState<any>({});

  const onVisitLink = (list: UserLinkObj) => {
    /** Google Analytics For which Link Visit the most*/
    ReactGA.initialize("UA-210740501-1");
    ReactGA.event({
      category: `${list?.social_media_name}`,
      action: `${list?.social_media_name}`,
      label: `${list?.social_media_name}`,
      value: 1,
    });

    if (list?.social_icon === "create-contact.png" || list?.is_contactCard) {
      let card = new vCard();
      card.version = `3.0`;
      card.firstName = `${userData?.profile_name}`;
      card.lastName = "";
      card.cellPhone = `${list?.link_value}`;
      card.email = `${userData?.email}`;
      card.url = `https://app.jod-e.com/viewprofile/${userData?.username}`;

      // check users details has emerguncy contact
      const emergencyDetails = userData?.links.filter(
        (linktype: any) => linktype.type === "emergency-contact"
      );
      if (emergencyDetails.length > 0) {
        card.otherPhone = `${
          JSON.parse(emergencyDetails[0].link_value).phoneNumber
        }`;
      }
      // check users details has personal details
      const personalDetails = userData?.links.filter(
        (linktype: any) => linktype?.type === "personal-information"
      );
      if (emergencyDetails.length > 0) {
        card.birthday = moment(
          JSON.parse(personalDetails[0]?.link_value).dob
        ).toDate();
      }

      const socialLinks = userData?.links.filter(
        (linktype: any) => linktype?.type === "links"
      );
      const result: any = _.map(socialLinks, (value: any) => [
        value?.social_media_name,
        `${value?.web_prefix}${value?.link_value}`,
      ]);

      if (!isEmpty(result)) {
        card.socialUrls = new Map<string, string>(result);
        // card.socialUrls = new Map<string, string> ([["key1", "value1"],["key2", "key2"]])
      }
      card.getFormattedString();
      const file = new Blob([card.getFormattedString()], {
        type: "text/vcard;charset=utf-8",
      });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(file);
      window.open(`${a}`);
      a.download = "vcard.vcf";
    } else if (list?.type === "shop") {
      //CHECK FOR TABLE NUMBER AND REDIRECT RESP''''
      if (activeView !== "" || null || undefined) {
        window.open(`${list?.web_prefix}?tableNo=${activeView}`, "_blank");
      } else {
        window.open(`${list?.web_prefix}`, "_blank");
      }
    } else if (list?.type === "document") {
      window.open(`${IMAGE_URL}${list.link_value}`, "_blank");
    } else {
      window.open(`${list?.web_prefix}${list.link_value}`, "_blank");
    }
  };

  function closeModal() {
    setIsOpen(false);
  }

  const openModal = (list: any, value: any) => {
    // const json = JSON.stringify(value);
    // const parsed = JSON.parse(json);
    // setListValue(parsed);
    setListData(list);
    setIsOpen(true);
  };

  return (
    <>
      <div className="px-4 py-8 sm:px-10 sm:py-10">
        <ul className="grid grid-cols-3 gap-6 sm:grid-cols-5">
          {userData?.links
            ?.sort((a: any, b: any) => (a.priority > b.priority ? 1 : -1))
            .map((list: any, index: any) => {
              return (
                <span key={index}>
                  {list.type === "bank-details" ? (
                    <li
                      key={index}
                      className={`${
                        userData?.background_pic === ""
                          ? "cursor-pointer select-none rounded-xl bg-cultured py-3 px-2"
                          : "cursor-pointer select-none rounded-xl bg-white/10 py-3 px-2 backdrop-blur-md"
                      }`}
                      onClick={() => openModal(list, list.link_value)}
                    >
                      <DisplayIcon icon={list?.social_icon} />
                      <h3 className="text-center text-sm font-medium leading-tight line-clamp-2 sm:text-base sm:leading-5">
                        {list?.social_media_name}
                      </h3>
                    </li>
                  ) : list.type === "emergency-contact" ? (
                    <li
                      key={index}
                      className={`${
                        userData?.background_pic === ""
                          ? "cursor-pointer select-none rounded-xl bg-cultured py-3 px-2"
                          : "cursor-pointer select-none rounded-xl bg-white/10 py-3 px-2 backdrop-blur-md"
                      }`}
                      onClick={() => openModal(list, list.link_value)}
                    >
                      <DisplayIcon icon={list?.social_icon} />
                      <h3 className="text-center text-sm font-medium leading-tight line-clamp-2 sm:text-base sm:leading-5">
                        {list?.social_media_name}
                      </h3>
                    </li>
                  ) : list.type === "personal-information" ? (
                    <li
                      key={index}
                      className={`${
                        userData?.background_pic === ""
                          ? "cursor-pointer select-none rounded-xl bg-cultured py-3 px-2"
                          : "cursor-pointer select-none rounded-xl bg-white/10 py-3 px-2 backdrop-blur-md"
                      }`}
                      onClick={() => openModal(list, list.link_value)}
                    >
                      <DisplayIcon icon={list?.social_icon} />
                      <h3 className="text-center text-sm font-medium leading-tight line-clamp-2 sm:text-base sm:leading-5">
                        {list?.social_media_name}
                      </h3>
                    </li>
                  ) : list.type === "event" ? (
                    <li
                      key={index}
                      className={`${
                        userData?.background_pic === ""
                          ? "cursor-pointer select-none rounded-xl bg-cultured py-3 px-2"
                          : "cursor-pointer select-none rounded-xl bg-white/10 py-3 px-2 backdrop-blur-md"
                      }`}
                      onClick={() => openModal(list, list.link_value)}
                    >
                      <DisplayIcon icon={list?.social_icon} />
                      <h3 className="text-center text-sm font-medium leading-tight line-clamp-2 sm:text-base sm:leading-5">
                        {list?.social_media_name}
                      </h3>
                    </li>
                  ) : list.type === "shop" ? (
                    <li
                      key={index}
                      className={`${
                        userData?.background_pic === ""
                          ? "cursor-pointer select-none rounded-xl bg-cultured py-3 px-2"
                          : "cursor-pointer select-none rounded-xl bg-white/10 py-3 px-2 backdrop-blur-md"
                      }`}
                      onClick={() => onVisitLink(list)}
                    >
                      <DisplayIcon icon={list?.social_icon} />
                      <h3 className="text-center text-sm font-medium leading-tight line-clamp-2 sm:text-base sm:leading-5">
                        {list?.social_media_name}
                      </h3>
                    </li>
                  ) : list.type === "multiDocument" ? (
                    <li
                      key={index}
                      className={`${
                        userData?.background_pic === ""
                          ? "cursor-pointer select-none rounded-xl bg-cultured py-3 px-2"
                          : "cursor-pointer select-none rounded-xl bg-white/10 py-3 px-2 backdrop-blur-md"
                      }`}
                      onClick={() => openModal(list, list.link_value)}
                    >
                      <DisplayIcon icon={list?.social_icon} />
                      <h3 className="text-center text-sm font-medium leading-tight line-clamp-2 sm:text-base sm:leading-5">
                        {list?.social_media_name}
                      </h3>
                    </li>
                  ) : (
                    <li
                      key={index}
                      className={`${
                        userData?.background_pic === ""
                          ? "cursor-pointer select-none rounded-xl bg-cultured py-3 px-2"
                          : "cursor-pointer select-none rounded-xl bg-white/10 py-3 px-2 backdrop-blur-md"
                      }`}
                      onClick={() => onVisitLink(list)}
                    >
                      <DisplayIcon icon={list?.social_icon} />
                      <h3 className="text-center text-sm font-medium leading-tight line-clamp-2 sm:text-base sm:leading-5">
                        {list?.social_media_name}
                      </h3>
                    </li>
                  )}
                </span>
              );
            })}
        </ul>
      </div>

      {isOpen && (
        <Transition appear show={isOpen} as={React.Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-50 overflow-y-auto"
            onClose={closeModal}
          >
            <div className="min-h-screen px-4 text-center">
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
              </Transition.Child>

              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={React.Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="my-8 inline-block w-full max-w-lg transform overflow-hidden rounded-md bg-white p-6 text-left align-middle shadow-xl transition-all">
                  {listData.type === "personal-information" && (
                    <PersonalInfo link={listData} />
                  )}

                  {listData.type === "emergency-contact" && (
                    <EmergencyContact link={listData} />
                  )}

                  {listData.type === "bank-details" && (
                    <BankDetails link={listData} />
                  )}

                  {listData.type === "event" && (
                    <EventBooking link={listData} />
                  )}

                  {listData.type === "multiDocument" && (
                    <MultiDocumentView link={listData} onClose={closeModal} />
                  )}
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      )}
    </>
  );
};

export default MyProfile;
